import regulationVersions from './regulationVersions'

export default {
  regulationVersions,
}
